module.exports = __webpack_public_path__ + "img/5.2347cda8.jpg";